	 <h3 class="ui primary header" >{{ modal.context.title }}
	<i class="link times icon" (click)="modal.deny(undefined)"></i>
	</h3>
 <div class="content" >
            <div class="scroll-wrapper ui basic segment" [ngClass]="{'loading':pending}">
            <div *ngIf="success || error" tamsyMargin marginY="10px">
              <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
              <esl-message-toast [(message)]="error"></esl-message-toast>
            </div>
            <div class="list-panel link" *ngFor="let document of lots" appMargin marginB="5">
                  <div fxLayout="row" fxLayoutAlign='space-between center' fxLayoutGap="15px">
                        <div fxFlex="auto">
                        <sui-checkbox ></sui-checkbox>
                        </div>
                        <div fxFlex="grow">
                              <h4 class="sub-header">{{document?.name}}</h4>
                        </div>
                  </div>
            </div>
            </div>
 </div>
      <div  class="actions">
    <button class="ui  basic primary button" (click)="modal.deny(undefined)">Cancel</button>
            <button class="ui  primary button" [ngClass]="{'yellow':pending}" [disabled]="pending" (click)="save()" autofocus>Done </button>

      </div>


